import { useQuery } from '@tanstack/react-query';
import { messagingService } from 'v2/services/messaging';

export const useChatAffiliates = (products: number[]) => {
  const { data, isLoading, isFetching, error, refetch } = useQuery<{
    data: { id: number; name: string; status: 'A' | 'P' }[];
  }>({
    queryKey: ['messages', 'affiliates', JSON.stringify(products)],
    queryFn: () => messagingService.listAffiliates(products),
    enabled: products.length > 0
  });

  return {
    affiliates: data?.data || [],
    isLoading,
    isFetching,
    error,
    refetch
  };
};
